import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { switchMap, take } from 'rxjs/operators';
import { environment } from '@env/environment';

const apiOrigin = new URL(environment.apiUrl).origin;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(apiOrigin + '/')) return next(req);

  const auth = inject(AuthService);
  return auth.getIdToken().pipe(
    take(1),
    switchMap((token) => {
      if (!token || req.headers.has('Authorization')) return next(req);
      return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
    })
  );
};
